import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useFolderGraphExport } from "src/core/contexts/FolderGraphExportContext";
import { useFolderGraph } from "src/core/hooks/folder/useFolderGraph";

export const FolderGraph = () => {
  const { containerRef, getPng } = useFolderGraph();
  const { registerGetPng } = useFolderGraphExport();
  const { t } = useTranslation();

  useEffect(() => {
    registerGetPng(getPng);
    return () => registerGetPng(null);
  }, [getPng, registerGetPng]);

  return (
    <div className="folder-graph-wrapper">
      <h2 className="flex items-center justify-center h-[50px] mx-20 mb-20 font-medium border-b border-border bg-background-secondary text-foreground relative z-10">
        {t("folder.graph.title")}
      </h2>
      <div ref={containerRef} className="w-full flex-1 min-h-[400px] relative z-0" />
    </div>
  );
};
